<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="copyright">First published in Great Britain in 2019 by Polygon, an imprint of Birlinn Ltd,</p>
<p class="copyright">West Newington House,<br/>10 Newington Road,<br/>Edinburgh<br/>EH9 1QS</p>
<p class="copyright"><a href="http://www.polygonbooks.co.uk" target="_blank">www.polygonbooks.co.uk</a></p>
<p class="copyright">1</p>
<p class="copyright">Copyright © Angus McAllister, 2019</p>
<p class="copyright">A short story entitled ‘The List’, which included material from this book, was published in the online version of <em>The Strand Magazine</em> in 2017.</p>
<p class="copyright">The right of Angus McAllister to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright">All rights reserved.</p>
<p class="copyright">This is a work of fiction. Names, characters, businesses, places, events and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p>
<p class="copyright">ISBN 978 1 84697 471 7<br/>eBook ISBN 978 1 78885 174 9</p>
<p class="copyright"><em>British Library Cataloguing-in-Publication Data</em><br/>A catalogue record for this book is available on request from the British Library.</p>
<p class="copyright">Typeset by <a href="http://3btype.com" target="_blank">3btype.com</a>, Rosyth</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?8a8b860c